import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '@/app/hooks';
import { fetchMeRequested } from '@/features/auth/authSlice';
import { LanguageSwitcher } from '@/components/LanguageSwitcher';
import { ThemeToggle } from '@/components/ThemeToggle';
import styles from './Header.module.scss';

export const Header: React.FC = () => {
  const { t } = useTranslation('header');
  const dispatch = useAppDispatch();
  const { checked, authenticated, user } = useAppSelector((state) => state.auth);

  useEffect(() => {
    dispatch(fetchMeRequested());
  }, [dispatch]);

  return (
    <header className={styles.header}>
      <div className={styles.inner}>
        <a href="/" className={styles.brand}>
          <img
            src="/assets/logo-primary-color.svg"
            alt="Airooki"
            className={styles.logo}
          />
        </a>
        <nav className={styles.nav}>
          <a href="#services" className={styles.navLink}>
            {t('services')}
          </a>
          <LanguageSwitcher />
          <ThemeToggle />
          {checked && authenticated ? (
            <>
              <span className={styles.userName}>{user?.name || user?.username || user?.email}</span>
              <a href="/auth/logout" className={styles.navCta}>
                {t('signOut')}
              </a>
            </>
          ) : (
            <>
              <a href="/auth/login" className={styles.navLink}>
                {t('signIn')}
              </a>
              <a href="/auth/register" className={styles.navCta}>
                {t('createAccount')}
              </a>
            </>
          )}
        </nav>
      </div>
    </header>
  );
};
